import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '../../../constants/TextConstants'
import { PageSizeWrapper, PaginationSelect } from './styles'
import { BqOption } from '@beeq/react'

const PageSizeControl = ({ defaultPageSize = 10, totalItems, onPageSizeChange, pageSizeControlSuffix = '' }) => {
  const pageSizeOptions = ['10', '20', '50', '100']

  return (
    <PageSizeWrapper>
      {Text.PaginationShowing}
      <PaginationSelect
        name='pagination-select'
        value={defaultPageSize}
        placeholder={`${defaultPageSize}/page`}
        data-testid='pagination-select'
        readonly
        disableClear
        onBqSelect={(e) => onPageSizeChange(parseInt(e.detail.value))}>
        {pageSizeOptions.map((item) => (
          <BqOption data-testid={`pagination-option-${item}`} key={item} value={item}>
            {`${item}/page`}
          </BqOption>
        ))}
      </PaginationSelect>
      {`${Text.PaginationFrom} ${totalItems} ${pageSizeControlSuffix.toLowerCase()}`}
    </PageSizeWrapper>
  )
}

export default PageSizeControl

PageSizeControl.propTypes = {
  defaultPageSize: PropTypes.number,
  totalItems: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  pageSizeControlSuffix: PropTypes.string
}
